<template>
    <v-card-text :class="`${secondColor}--text pb-0`" v-if="show && percent > 0">
        <div class="text-subtitle-1 font-weight-medium text-center mb-1">{{ Math.floor(percent) }}%</div>

        <div class="battery-bar">
            <v-progress-linear :value="percent" :color="secondColor" background-opacity="0.25" height="8" rounded :striped="isCharging" />
            <div class="battery-mark" title="80%" />
        </div>
        <div class="d-flex align-center justify-center text-caption text-no-wrap">
            <v-icon small :color="secondColor" class="mr-1">{{ batteryIcon }}</v-icon>
            Bateria
        </div>

        <div class="d-flex mt-2" v-if="rangeInKm || isCharging">
            <div class="half-col text-center">
                <div class="text-subtitle-1 font-weight-medium text-no-wrap">{{ rangeInKm ? `${rangeInKm} km` : "--" }}</div>
                <div class="d-flex align-center justify-center text-caption text-no-wrap">
                    <v-icon small :color="secondColor" class="mr-1">directions_car</v-icon>
                    Autonomia estimada
                </div>
            </div>
            <div class="half-col text-center" v-if="isCharging">
                <div class="text-subtitle-1 font-weight-medium text-no-wrap">{{ timeTo80Text }}</div>
                <div class="d-flex align-center justify-center text-caption text-no-wrap">
                    <v-icon small :color="secondColor" class="mr-1">timer</v-icon>
                    Para 80%
                </div>
            </div>
        </div>
    </v-card-text>
</template>

<script>
// Autonomia e tempo para 80% são estimados pela API (BatteryEstimator)
export default {
    props: {
        plug: {
            required: true,
        },
        secondColor: {
            required: true,
        },
        show: {
            required: true,
        },
    },

    computed: {
        percent() {
            return Number(this.plug.percent || 0);
        },
        isCharging() {
            return this.plug.status == "Charging";
        },
        batteryIcon() {
            if (this.isCharging) {
                return "battery_charging_full";
            }
            return this.percent >= 95 ? "battery_full" : "battery_std";
        },
        rangeInKm() {
            return this.plug.rangeKm || null;
        },
        minutesTo80() {
            return this.plug.estimatedMinutesTo80Percent || null;
        },
        timeTo80Text() {
            if (!this.minutesTo80) {
                return "--";
            }
            if (this.minutesTo80 < 60) {
                return `${this.minutesTo80} min`;
            }
            const minutes = this.minutesTo80 % 60;
            return `${Math.floor(this.minutesTo80 / 60)}h ${String(minutes).padStart(2, "0")}min`;
        },
    },
}
</script>

<style scoped>
.half-col {
    flex: 1 1 0;
    min-width: 0;
}

.battery-bar {
    position: relative;
    margin-bottom: 4px;
}

.battery-mark {
    position: absolute;
    top: -3px;
    bottom: -3px;
    left: 80%;
    width: 2px;
    background-color: currentColor;
    opacity: 0.7;
}
</style>
